// WebView 통신 유틸리티

/**
 * 챗봇 열기 함수
 * - WebView 환경: React Native로 메시지 전달
 * - 일반 브라우저: 새 탭으로 열기
 */
export const openChatbot = (url: string = 'https://helper.onhub.ai.kr/client') => {
    // React Native WebView 환경 확인
    if (window.ReactNativeWebView) {
        console.log('[WebView] React Native로 챗봇 열기 메시지 전달:', url);

        window.ReactNativeWebView.postMessage(
            JSON.stringify({
                type: 'OPEN_CHATBOT',
                url: url
            })
        );
    } else {
        // 일반 웹 브라우저에서는 새 탭으로 열기
        console.log('[WebView] 웹 브라우저에서 새 탭으로 열기:', url);
        window.open(url, '_blank', 'noopener,noreferrer');
    }
};

/**
 * ⭐ 외부 링크 열기 (플러스몰 배너 등)
 * - WebView 환경: 기존 OPEN_CHATBOT 핸들러를 재사용해 인앱 브라우저로 열기
 *   (앱에 이미 배포된 기능이라 앱 재빌드 없이 동작합니다)
 * - 일반 브라우저: 새 탭으로 열기
 */
export const openExternalLink = (url: string) => {
    if (!url) return;

    if (window.ReactNativeWebView) {
        console.log('[WebView] 인앱 브라우저로 열기:', url);

        window.ReactNativeWebView.postMessage(
            JSON.stringify({
                type: 'OPEN_CHATBOT',
                url: url
            })
        );
    } else {
        console.log('[WebView] 웹 브라우저에서 새 탭으로 열기:', url);
        window.open(url, '_blank', 'noopener,noreferrer');
    }
};

// TypeScript 타입 선언
declare global {
    interface Window {
        ReactNativeWebView?: {
            postMessage: (message: string) => void;
        };
    }
}